'use strict';

var selectors = {
    container: '.js-video-player',
    toggle: '.js-video-player-sound-toggle',
    video: '.video-player__video'
};

var classes = {
    isUnmuted: 'is-unmuted'
};

function setMuted(container, muted) {
    var videos = container.querySelectorAll(selectors.video);
    videos.forEach(function (video) {
        video.muted = muted;
        if (!muted) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () { /* autoplay-with-sound may still be blocked; ignore */ });
            }
        }
    });
    container.classList.toggle(classes.isUnmuted, !muted);
}

function bindToggle(container) {
    var toggle = container.querySelector(selectors.toggle);
    if (!toggle) {
        return;
    }

    toggle.addEventListener('click', function () {
        var isCurrentlyUnmuted = container.classList.contains(classes.isUnmuted);
        setMuted(container, isCurrentlyUnmuted);
        toggle.setAttribute('aria-pressed', String(!isCurrentlyUnmuted));
    });
}

module.exports = {
    init: function init() {
        var containers = document.querySelectorAll(selectors.container);
        containers.forEach(function (container) {
            if (container.dataset.allowSound !== 'true') {
                return;
            }
            bindToggle(container);
        });
    }
};
